import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import axios from "axios";
import FeedbackForm from "../components/contacts/FeedbackForm";


const HaveQuery = () => {
	
	const toggleChatWindow = () => {
		const chatWindow = document.getElementById('chatWindow');
		chatWindow.style.display = chatWindow.style.display === 'flex' ? 'none' : 'flex';
	};
	
	const startConversation = () => {
		document.getElementById('chatHome').style.display = 'none'; // Hide the initial content
		document.getElementById('chatIframe').style.display = 'block'; // Show the iframe
	};
	
	const goBackToHome = () => {
		document.getElementById('chatIframe').style.display = 'none'; // Hide the iframe
		document.getElementById('chatHome').style.display = 'block'; // Show the initial content
	};
	
	const [data, setData] = useState(null)
	
	useEffect(() => {
		axios.get('https://cms.shantasecurities.com/api/get-req-data/settings-data')
		     .then(function (response) {
			     setData(response)
		     })
		     .catch(function (error) {
			     console.log(error);
		     })
	}, []);
	
	
	const footerData = data?.data?.data;
	const [show, setShow] = useState(false);
	const handleClose = () => setShow(false);
	const handleShow = (e) => {
		setShow(true)
	}
	
	
	
	
	return (<StyledComponent className={''}>
		<div className="chat-icon" onClick={handleShow}>
			<p>Have Query</p>
			<div className="chat-icon-dev">
				<svg width={'20px'} height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 17V16.9929M9.13721 9C9.51949 7.84083 10.6566 7 11.9999 7C12.3506 7 12.6872 7.05731 13 7.16262M11.9998 14.8571C11.9998 11.6429 14.9998 12.3571 14.9998 9.85714C14.9998 9.55851 14.9516 9.27058 14.8624 9M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#2b817e" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path> </g></svg>
			</div>
		</div>
		<FeedbackForm show={show} handleClose={handleClose}/>
		
	
	</StyledComponent>);
};

const StyledComponent = styled.section`

    position: relative;
    z-index: 99999;

    .chat-icon {
        position: fixed;
        bottom: 80px;
        right: 20px;
        background: #2b817e;
        transition: transform 0.2s;
        border-radius: 16px 18px 16px 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 6px;
        cursor: pointer;
        z-index: 1000;
        gap: 10px;
        height: 44px;
        padding-left: 16px;
        .chat-icon-dev {
            border-radius: 50%;
            display: flex;
            width: 40px;
            height: 40px;
            background: white;
            border: 4px solid #2b817e;
		        align-items: center;
		        justify-content: center;
        }

        p {
            color: white;
        }


        svg {
            width: 25px;
            height: 25px;
        }

        .st0 {
            fill-rule: evenodd;
            clip-rule: evenodd;
            fill: #FFFFFF;
        }
    }

    .chat-window {
        position: fixed;
        bottom: 90px;
        right: 20px;
        width: 350px;
        height: 450px;
        background: #ffffff;
        border-radius: 15px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
        overflow: hidden;
        display: none;
        flex-direction: column;
        z-index: 999;

        .chat-home {
            background: linear-gradient(135deg, #2b817d, #3a9692, #82a3bb, #708ea4, #5e7b90);
            height: 100%;
            width: 100%;
            padding: 20px 20px;
        }
    }

    #chatIframe {
        height: calc(100% - -2px);
        position: relative;
        width: 100%;

        .chat-header {
            background: linear-gradient(135deg, #2b817d, #3a9692, #82a3bb, #708ea4, #5e7b90);

            color: white;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 15px;
            position: absolute;
            width: 100%;
            z-index: 1;

            h6 {
                color: white;
                font-size: 16px;
                line-height: 20px;
            }

            img {
                width: 40px;
                height: 40px;
                background: #fff;
                margin-right: 10px;
                border-radius: 50px;
                padding: 5px;
            }

            .header-text {
                font-size: 16px;
                font-weight: bold;
                display: flex;
                color: #fff;
                align-items: center;

                .back-button {
                    cursor: pointer;

                    svg {
                        height: 25px;
                        margin-right: 10px;

                        path {
                            fill: white;
                        }
                    }
                }

                i {
                    margin-right: 10px;
                    font-size: 19px;
                    font-weight: 500;
                }
            }
        }

        .chat-iframe {
            width: 100%;
            border: none;
            height: 100%;
            padding: 10px;
            background: #101010;
            position: relative;
            top: 0;
            z-index: 0;

            .iframe {
                width: 100%;
                border: none;
                height: 100%;
            }
        }
    }

    .chat-content {
        flex-grow: 1;
        padding: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        color: #333333;
        height: calc(100% - 80px);
        background: linear-gradient(93deg, rgba(255, 255, 255, .1) 3.13%, rgba(255, 255, 255, .1) 98.7%);
        -webkit-backdrop-filter: blur(10px);
        backdrop-filter: blur(10px);
        border-radius: 24px;
        border: 2px solid #ffffff33;
        margin-top: 20px;
    }

    .chat-content {
        button {
            padding: 10px 20px;
            font-size: 16px;
            background: #fff;
            color: #000;
            border: none;
            border-radius: 10px;
            cursor: pointer;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
            display: flex;
            flex-direction: column;
            width: 100%;
            text-align: center;
            align-items: center;

            img {
                margin-bottom: 10px;
            }

            p {
                margin: 0;
            }
        }

        h1 {
            font-size: 24px;
            font-weight: bold;
            margin-bottom: 10px;
            color: #fff;
            line-height: 30px;
        }

        p {
            font-size: 16px;
            margin-bottom: 20px;
            color: #fff;
        }
    }

`;

export default HaveQuery;
